import { Button, Spinner } from 'react-bootstrap';

function RemoveButton({
  text,
  onClick,
  className,
  variant = 'primary',
  disabled = false,
  loading = false,
}) {
  return (
    <Button
      onClick={() => onClick()}
      variant={variant}
      disabled={disabled}
      className={`d-flex align-items-center justify-content-center ${className}`}
    >
      {loading ? (
        <>
          <Spinner
            as='span'
            animation='border'
            size='sm'
            role='status'
            aria-hidden='true'
            className='me-2'
          />
          <span className='visually-hidden'>Loading...</span>
        </>
      ) : (
        <span
          className='material-symbols-outlined me-1'
          style={{ fontSize: '18px' }}
        >
          remove
        </span>
      )}

      {text}
    </Button>
  );
}

export default RemoveButton;
